import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const Content = styled(Grid)`
  ol {
    list-style: decimal;
    padding-left: ${(props) => props.theme.x2spacePx}px;
    color: ${({ theme }) => theme.color.noir};
    ${({ theme }) => theme.typography.small};

    li {
      padding-left: ${(props) => props.theme.x1spacePx}px;
    }
  }
`;

export const NoticeSection = styled(Grid)`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  padding: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  background: ${({ theme }) => theme.color.spaceGray};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
`;
